export default "__VITE_ASSET__BdrM04dE__"